module.exports = __webpack_public_path__ + "static/media/bn.d38565ec.svg";